import React from 'react'
import logotipo from '../../../assets/images/logo-muvicard.png'

const LogotipoMuvicard = ({ className }) => (
	<img
		className={`logotipo ${className}`}
		src={logotipo}
		alt="Logotipo Muvicard"
		width="199px"
	/>
)

export default LogotipoMuvicard
